var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FA372C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5017 12V14.78",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5017 32.8451V35.6251",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.866 18.8094C28.249 16.9814 27.0837 15.1762 24.3644 15.1762C23.2448 15.1762 22.3079 15.5647 21.6224 16.1816C19.543 17.9868 20.0914 21.0945 22.445 22.5569C24.7986 24.0194 26.8552 24.2479 28.3404 26.4415C30.0771 28.8637 28.2262 32.7483 24.6387 32.7483C21.9194 32.7483 20.617 30.9202 20 29.115",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevenue);
export default __webpack_public_path__ + "static/media/icon-revenue.0536fbe4f4a72dfbead4acf91a27b5ae.svg";
export { ForwardRef as ReactComponent };